export const GetTokenHolders = async (id: string) =>
  fetch(`/api/market/holders/${id}`, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then((e) => e.json());

export const GetTokenHistory = async (id: string) =>
  fetch(`/api/market/history/${id}`, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then((e) => e.json());
